import { combineReducers } from "redux";
import searchReducer from "./search/reducer";
import robotReducer from "./robot/reducer";
import { IRootState } from "./store";

const rootReducer = combineReducers<IRootState>({
  search: searchReducer,
  robots: robotReducer,
});

export default rootReducer;
